import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { serviceMenuItems } from '../../data/navigation';
import { isExternalUrl, linkTargetProps } from '../../utils/links';
interface ServicesMenuProps {
  id: string;
  onNavigate: () => void;
}
export function ServicesMenu({
  id,
  onNavigate
}: ServicesMenuProps) {
  const reduce = useReducedMotion();
  return <motion.div id={id} initial={{
    opacity: 0,
    y: reduce ? 0 : -6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: reduce ? 0 : -4
  }} transition={{
    duration: 0.18,
    ease: [0.23, 1, 0.32, 1]
  }} className="absolute left-0 top-full z-50 mt-3 w-[460px] border border-line bg-paper-bright shadow-[0_24px_48px_-24px_rgba(23,23,25,0.35)]" data-id="element-198" data-mp="f3tcqk9ptbs0">
      <div aria-hidden="true" className="h-[3px] w-14 bg-brand" data-id="element-199" data-mp="3sg3jpzypxdpb" />
      <ul className="py-2" data-id="element-200" data-mp="3nhs8plwosx5i">
        {serviceMenuItems.map(item => {
        const external = isExternalUrl(item.href);
        return <li key={item.label} data-id="element-201" data-mp="cl2g3ih17kvl">
              <a href={item.href} onClick={onNavigate} {...linkTargetProps(item.href)} className="group flex items-start justify-between gap-6 px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-paper-deep" data-id="element-202" data-mp="hd3ouuezqtgv">
                <span data-id="element-203" data-mp="vcv7x9kd701q">
                  <span className="block font-display text-[19px] font-semibold uppercase tracking-[0.03em] text-ink" data-id="element-204" data-mp="vcd1jk3zn5g3">
                    {item.label}
                  </span>
                  <span className="mt-0.5 block text-sm text-steel" data-id="element-205" data-mp="mc6uafyvv1pd">{item.description}</span>
                </span>
                {external ? <ArrowUpRightIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-steel transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-206" data-mp="r9yk94fywdqx" /> : <ArrowRightIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-steel transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-207" data-mp="1hlafqojvwkxm" />}
              </a>
            </li>;
      })}
      </ul>
      <a href="#services" onClick={onNavigate} className="flex items-center justify-between border-t border-line px-6 py-4 text-sm font-semibold text-ink transition-colors duration-150 ease-out hover:text-brand-deep" data-id="element-208" data-mp="13tvipdt56j7k">
        View all services on this page
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-209" data-mp="ty29o4emt7uj" />
      </a>
    </motion.div>;
}